type UnknownRecord = Record<string, unknown>;

const asRecord = (value: unknown): UnknownRecord | null =>
  typeof value === 'object' && value !== null ? (value as UnknownRecord) : null;

const asNonEmptyString = (value: unknown): string =>
  typeof value === 'string' && value.length > 0 ? value : '';

const asMessageList = (value: unknown): string => {
  if (!Array.isArray(value)) {
    return '';
  }

  const messages = value.filter(
    (message): message is string => typeof message === 'string' && message.length > 0
  );
  return messages.join(', ');
};

export const getBlogErrorMessage = (error: unknown, fallback = ''): string => {
  const errorRecord = asRecord(error);
  const response = asRecord(errorRecord?.response);
  const errorData = response?.data;
  const errorDataRecord = asRecord(errorData);
  const nestedMessage = asRecord(errorDataRecord?.message);

  const nestedMessages = asMessageList(nestedMessage?.message);
  if (nestedMessages) {
    return nestedMessages;
  }

  const nestedMessageText = asNonEmptyString(nestedMessage?.message);
  if (nestedMessageText) {
    return nestedMessageText;
  }

  const nestedErrorText = asNonEmptyString(nestedMessage?.error);
  if (nestedErrorText) {
    return nestedErrorText;
  }

  const directMessages = asMessageList(errorDataRecord?.message);
  if (directMessages) {
    return directMessages;
  }

  const directMessage = asNonEmptyString(errorDataRecord?.message);
  if (directMessage) {
    return directMessage;
  }

  const directError = asNonEmptyString(errorDataRecord?.error);
  if (directError) {
    return directError;
  }

  const errorMessage = asNonEmptyString(errorRecord?.message);
  if (errorMessage) {
    return errorMessage;
  }

  const responseStatusText = asNonEmptyString(response?.statusText);
  if (responseStatusText) {
    return responseStatusText;
  }

  const stringData = asNonEmptyString(errorData);
  if (stringData) {
    return stringData;
  }

  if (typeof response?.status === 'number') {
    return `Error ${response.status}: ${responseStatusText || 'Request failed'}`;
  }

  return fallback;
};

export const isCanceledBlogRequest = (error: unknown): boolean =>
  asRecord(error)?.name === 'CanceledError';
